import { render } from "./DropDownCategories.vue?vue&type=template&id=24df1d73&scoped=true"
import script from "./DropDownCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownCategories.vue?vue&type=script&setup=true&lang=js"

import "./DropDownCategories.vue?vue&type=style&index=0&id=24df1d73&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24df1d73"],['__file',"resources/js/modules/labelinsight-products/components/filter/DropDownCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24df1d73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24df1d73', __exports__)) {
    api.reload('24df1d73', __exports__)
  }
  
  module.hot.accept("./DropDownCategories.vue?vue&type=template&id=24df1d73&scoped=true", () => {
    api.rerender('24df1d73', render)
  })

}


export default __exports__